module.exports = __webpack_public_path__ + "static/img/patent-swiper-3.66436e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/patent-swiper-3.png
// module id = 1dC6
// module chunks = 1